import type { FC } from "react";
import { Link, Outlet } from "react-router";
import backgroundDark from "@/assets/backgroundDark.png";
import backgroundLight from "@/assets/backgroundLight.png";
import icon from "@/assets/icon.svg";
import { useDarkModeInformation } from "@/lib/common/DarkModeContext";

export const FrameAuth: FC = () => {
	const { isEnabled } = useDarkModeInformation();

	return (
		<div className="@container grid min-h-svh lg:grid-cols-2">
			<div className="flex flex-col gap-4 p-6 @md:p-10">
				<Link to="/login">
					<div className="flex justify-center gap-2 @md:justify-start font-medium">
						<img src={icon} className="h-6 w-6" />
						Fyendal's Collection
					</div>
				</Link>
				<div className="flex flex-1 items-center justify-center">
					<div className="w-full max-w-96">
						<Outlet />
					</div>
				</div>
				<div className="text-center text-sm">
					By signing in to Fyendal&apos;s Collection, you agree to
					our <a href="https://fyendalscollection.com/terms-and-conditions" target="_blank" rel="noopener noreferrer" className="underline underline-offset-4">Terms and Conditions</a>.
				</div>
			</div>
			<div className="bg-muted relative hidden lg:block">
				<img
					src={isEnabled ? backgroundDark : backgroundLight}
					alt="Image"
					className="absolute inset-0 h-full w-full object-cover bg-background"
				/>
			</div>
		</div>
	);
};
